<template>
  <div
    v-if="whatsappStyle"
    id="preguntas"
    class="wa-chat-list"
  >
    <div
      v-for="(chatW, i) in chatsVisibles"
      :key="claveChat(chatW, i)"
      :class="['wa-contact', { 'wa-contact-active': chatEstaActivo(chatW) }]"
      @click="seleccionarChat(chatW)"
    >
      <div class="wa-contact-avatar-wrap">
        <v-avatar :color="chatW.ri ? '#00a884' : '#dfe5e7'" size="48">
          <v-icon :color="chatW.ri ? 'white' : (chatW.twilio_asignado ? 'green' : 'red')">
            {{ chatW.twilio_asignado ? 'mdi-cash' : 'mdi-account' }}
          </v-icon>
        </v-avatar>
      </div>

      <div class="wa-contact-body">
        <div class="wa-contact-top">
          <div class="wa-contact-name">
            <v-icon small v-if="chatW.idetiquetas_inscritos" :color="chatW.color_inscritos">mdi-label</v-icon>
            {{ tituloListaChat(chatW) }}
          </div>
          <div class="wa-contact-time">{{ horaChat(chatW) }}</div>
        </div>

        <div class="wa-contact-middle" v-if="subtituloListaChat(chatW)">
          {{ subtituloListaChat(chatW) }}
        </div>

        <div class="wa-contact-bottom">
          <div class="wa-last-message">
            <v-icon small class="mr-1" v-if="chatW.mio" color="#8696a0">mdi-check-all</v-icon>
            {{ resumenMensaje(chatW) }}
          </div>
          <div class="wa-contact-badges">
            <v-chip x-small label dark color="red" v-if="!chatW.alumno">SIN ALUMNO</v-chip>
            <v-chip x-small label dark color="primary" v-if="chatW && chatW.plantel">{{ chatW.plantel }}</v-chip>
            <v-chip
              v-if="chatW.city"
              x-small
              label
              dark
              :color="chipCityColor(chatW)"
            >
              {{ chatW.city.toUpperCase() }}
            </v-chip>
            <v-chip
              v-if="chatW.tiemporestante !== undefined && chatW.tiemporestante !== null"
              x-small
              label
              dark
              class="wa-time-chip"
              :color="chatW.tiemporestante > 2 ? 'green' : (chatW.tiemporestante > 0 ? 'yellow' : 'red')"
            >
              {{ chatW.tiemporestante }}
              <v-icon x-small right>mdi-clock</v-icon>
            </v-chip>
            <span v-if="chatW.sinleer > 0 || chatW.mio == 0" class="wa-unread">
              {{ chatW.sinleer > 0 ? chatW.sinleer : 1 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="hayMasConversaciones" class="pa-3">
      <v-btn color="#00a884" dark block rounded depressed @click="limite += 50">
        Mostrar más conversaciones
      </v-btn>
    </div>
  </div>

  <div
    v-else
    :style="`height: ${tamanioPantalla}px; overflow: auto;`"
    id="preguntas"
  >
    <v-list dense class="elevation-0">
      <template v-for="(chatW, i) in chatsVisibles">
        <v-divider v-if="i > 0" :key="'div-' + claveChat(chatW, i)" inset></v-divider>

        <v-list-item
          :key="claveChat(chatW, i)"
          @click="seleccionarChat(chatW)"
          :class="chatEstaActivo(chatW) ? 'wa-list-item-active' : '' "
        >
          <v-list-item-avatar color="grey lighten-3">
            <v-icon :color="chatW.ri ? 'green' : 'red'">
              {{ chatW.twilio_asignado ? 'mdi-cash' : 'mdi-account' }}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              <v-icon v-if="chatW.idetiquetas_inscritos" :color="chatW.color_inscritos">mdi-label</v-icon>
              <v-chip x-small color="green" dark v-if="chatW.tiemporestante > 2" class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small color="yellow" v-else-if="chatW.tiemporestante > 0" class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small color="red" dark v-else class="ml-2">{{ chatW.tiemporestante }}<v-icon x-small right>mdi-clock</v-icon></v-chip>
              <v-chip x-small color="primary" v-if="chatW && chatW.plantel" :class="'ml-2 white--text'">{{ chatW.plantel }}</v-chip>
              <v-chip x-small :color="chipCityColor(chatW)" v-if="chatW && chatW.city" :class="'ml-2 white--text'">{{ chatW.city.toUpperCase() }}</v-chip>
            </v-list-item-title>

            <v-list-item-subtitle>
              <v-icon small class="mr-1" v-if="chatW.mio" color="grey">mdi-check-all</v-icon>
              <v-chip x-small color="red" v-if="!chatW.alumno" :class="'ml-2 white--text'">SIN ALUMNO</v-chip>
              <b>{{ chatW.alumno }}</b>
              <br/>
              <span v-if="chatW.usuario">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <span v-if="chatW.type == 1">{{ chatW.mensaje }}</span>
                      <span v-if="chatW.type == 2">Imagen</span>
                      <span v-if="chatW.type == 3">Audio</span>
                      <span v-if="chatW.type == 4">PDF</span>
                    </span>
                  </template>
                  <span v-if="chatW.type == 1">{{ chatW.mensaje }}</span>
                  <span v-if="chatW.type == 2">
                    <img v-if="chatW.mio == 0" :src="url2 + chatW.MediaUrl0" alt="Red dot" width="100"/>
                    <img v-if="chatW.mio == 1" :src="url2 + chatW.MediaUrl0" alt="Red dot" width="100"/>
                  </span>
                  <span v-if="chatW.type == 3">Audio, abrir para escuchar</span>
                  <span v-if="chatW.type == 4">PDF, abrir para verlo</span>
                </v-tooltip>
              </span>
              <span v-else>El usuario no tiene whatsapp</span>
            </v-list-item-subtitle>

            <span class="grey--text">
              <v-icon small class="mr-1">mdi-whatsapp</v-icon>
              {{ chatW.usuario }}
            </span>
          </v-list-item-content>

          <v-list-item-icon>
            <v-list-item-action-text>{{ chatW.ultimmensaje }}</v-list-item-action-text>
            <v-list-item-action-text>{{ chatW.fecha_ultimo_mensaje }}</v-list-item-action-text>
            <v-chip v-if="chatW.sinleer > 0 || chatW.mio == 0" :color="chatW.mio == 0 ? 'green' : ''" small dark class="pa-2">
              {{ 1 }}
            </v-chip>
          </v-list-item-icon>
        </v-list-item>

        <div
          v-if="hayMasConversaciones && i === chatsVisibles.length - 1"
          :key="'more-' + claveChat(chatW, i)"
        >
          <v-btn color="success" @click="limite += 50" block tile>Mostrar más mensajes +50</v-btn>
        </div>
      </template>
    </v-list>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapActions } from 'vuex'
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import MensajesWppTwilio from '@/components/whatsapp/MensajesTwilioWpp.vue'
  import validarErrores from '@/mixins/validarErrores'

  export default {
    props: {
      filterChats: Array,
      whatsappStyle: { type: Boolean, default: false },
      /** Chat abierto en el padre; mantiene la selección aunque la lista se refresque */
      chatActivo: { type: Object, default: null },
    },

    components: {
      Alerta,
      carga,
      MensajesWppTwilio,
    },

    mixins: [validarErrores],

    data: () => ({
      chat: null,
      limite: 100,
      url: 'https://academicokpi.club/imagenes-whatsapp/',
      url2: 'https://escuelakpi.club/imagenes-whatsapp/',
    }),

    computed: {
      tamanioPantalla () {
        return this.$vuetify.breakpoint.height - 330
      },

      chatsLista () {
        return ( this.filterChats || [] ).filter( chat => chat && typeof chat === 'object' )
      },

      chatsVisibles () {
        return this.chatsLista.slice( 0, this.limite + 1 )
      },

      hayMasConversaciones () {
        return this.chatsLista.length > this.chatsVisibles.length
      },
    },

    methods: {
      claveChat ( chatW, index ) {
        if ( !chatW ) return `chat-vacio-${ index }`
        const partes = [ chatW.usuario, chatW.matricula, chatW.id_alumno, chatW.id_grupo ].filter( valor => valor != null && valor !== '' )
        return partes.length ? `${ partes.join( '-' ) }-${ index }` : `chat-${ index }`
      },

      seleccionarChat (chatW) {
        this.chat = chatW
        this.$emit('verChat', chatW)
      },

      chatEstaActivo (chatW) {
        const activo = this.chatActivo || this.chat
        if (!activo || !chatW) return false
        if (activo.usuario != null && chatW.usuario != null && activo.usuario !== '' && chatW.usuario !== '') {
          return String(activo.usuario) === String(chatW.usuario)
        }
        if (activo.id_alumno != null && chatW.id_alumno != null) {
          return String(activo.id_alumno) === String(chatW.id_alumno)
        }
        if (activo.matricula != null && chatW.matricula != null) {
          return String(activo.matricula) === String(chatW.matricula)
        }
        return activo === chatW
      },

      chipCityColor (chat) {
        if (chat && chat.city) {
          if (chat.city == 'cdmx') return 'pink accent-4'
          if (chat.city == 'mty') return 'deep-orange accent-3'
          if (chat.city == 'gdl') return 'teal accent-4'
        }
        return 'teal darken-1'
      },

      getNombre (texto) {
        if (!texto || !texto.usuario) return ''
        return String(texto.usuario).replace('whatsapp:+52', '')
      },

      tituloListaChat (chatW) {
        if (chatW && chatW.alumno) return chatW.alumno
        return 'Sin alumno asignado'
      },

      subtituloListaChat (chatW) {
        if (!chatW) return ''
        const phone = this.getNombre(chatW)
        if (chatW.matricula && phone) return `${chatW.matricula} · ${phone}`
        if (chatW.matricula) return String(chatW.matricula)
        return phone
      },

      horaChat (chatW) {
        return chatW.fecha_ultimo_mensaje || chatW.ultimmensaje || ''
      },

      resumenMensaje (chatW) {
        if (!chatW || !chatW.usuario) return 'El usuario no tiene whatsapp'
        if (chatW.type == 2) return 'Imagen'
        if (chatW.type == 3) return 'Audio'
        if (chatW.type == 4) return 'PDF'
        return chatW.mensaje || ''
      },
    },
  }
</script>

<style scoped lang="scss">
  @import '@/assets/styles/twilio-whatsapp-layout.scss';

  .wa-list-item-active {
    background: #c8efe4 !important;
    box-shadow: inset 5px 0 0 #008f6f;
  }

  .wa-list-item-active:hover {
    background: #c8efe4 !important;
  }

  #preguntas::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  #preguntas::-webkit-scrollbar:vertical {
    width: 4px !important;
  }

  #preguntas::-webkit-scrollbar-button:increment,
  #preguntas::-webkit-scrollbar-button {
    display: none;
  }

  #preguntas::-webkit-scrollbar:horizontal {
    display: none;
  }

  #preguntas::-webkit-scrollbar-thumb {
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }
</style>
